import React, { useState }  from "react";

import { IconButton, Button } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import ToolTip from "@mui/material/Tooltip";
import {asyncLogParams, uploadBlobToStorage} from "../components-logging/firebaseManager";
import SDgetDataByName from "../helpers/SDgetDataByName";
// import piexif from "piexifjs";
import piexif from "../../node_modules/piexifjs/piexif.js"
// import piexif from "piexif"
// import piexif from "piexif";
import fetchImageBinaryData from "../helpers/fetchBinaryImage";
// var ExifParser = require('exif-parser')
// import EXIF from "exif-js";
import getRandomId from "../helpers/getRandomID";



// Function to find the value of a parameter by name
function findParameterValue(paramName, paramdefs) {
  const parameter = paramdefs.find(param => param.name === paramName);
  return parameter ? parameter.value : undefined;
}

async function downloadFile(url, name) {
  const response = await fetch(url);
  const blob = await response.blob();
  // const filename = url.substring(url.lastIndexOf('/') + 1);
  const filename = name;
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link); // Append link to the DOM
  link.click();
  document.body.removeChild(link); // Remove link from the DOM
}

// Function to modify the EXIF data
const modifyExifData = (imageArrayBuffer) => {
  // const exifData = piexif.load(imageArrayBuffer);
  // console.log("DownloadScreenCapButton: exifData", exifData);

  var Exif = {};
  // Modify the EXIF data as needed
  var zeroth = {};
  var exif = {};
  var gps = {};
  zeroth[piexif.ImageIFD.Make] = "Make";
  zeroth[piexif.ImageIFD.XResolution] = [777, 1];
  zeroth[piexif.ImageIFD.YResolution] = [777, 1];
  zeroth[piexif.ImageIFD.Software] = "Piexifjs";
  exif[piexif.ExifIFD.DateTimeOriginal] = "2010:10:10 10:10:10";
  exif[piexif.ExifIFD.LensMake] = "LensMake";
  exif[piexif.ExifIFD.Sharpness] = 777;
  exif[piexif.ExifIFD.LensSpecification] = [[1, 1], [1, 1], [1, 1], [1, 1]];
  gps[piexif.GPSIFD.GPSVersionID] = [7, 7, 7, 7];
  gps[piexif.GPSIFD.GPSDateStamp] = "1999:99:99 99:99:99";
  var exifObj = {"0th":zeroth, "Exif":exif, "GPS":gps};
  // Add or modify other EXIF tags as required

  // Serialize the modified EXIF data back to binary
  const modifiedExif = piexif.dump(exifObj);

  const reader = new FileReader();
    reader.onload = (event) => {

  // Insert the modified EXIF data back into the image binary data
      const modifiedImageArrayBuffer = piexif.insert(modifiedExif, event.target.result);
  // const modifiedImageArrayBuffer = piexif.insert(modifiedExif, imageArrayBuffer);

  // Create a Blob from the modified image data
  const modifiedImageBlob = new Blob([modifiedImageArrayBuffer], {
    type: "image/png", // Change the type to match your image format
  });

  return modifiedImageBlob;
  }
}

  // Function to trigger the download of a Blob
  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = filename;
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
  };
export  function  DownloadScreenCapButton(props) {
  const { sdApi, paramDefs, setBusyState, setProgress } = props;
  const [modifiedImageBlob, setModifiedImageBlob] = useState(null);
  const [highresImageBlob, sethighresImageBlob] = useState(null);

  const materialAngelHair = "https://firebasestorage.googleapis.com/v0/b/imagewall-v2.appspot.com/o/RenderAssets%2FAngelHair.zip?alt=media&token=2dd9a3ef-9bc5-4211-8c1b-76254dd84d22"
  const materialSolanum = "https://firebasestorage.googleapis.com/v0/b/imagewall-v2.appspot.com/o/RenderAssets%2FSolanum.zip?alt=media&token=9b561bd8-677b-4fc4-940c-28efe1180e36"


  
  const DesignID = getRandomId(6);
  

  const downloadImage = async () => {

    setBusyState(true)
    setProgress(.1)

    //get name of material
    const materialName = await sdApi.current.parameters.get({ name: "Material" }).data[0].value
    console.log("DownloadScreenCapButton: materialName", materialName);

    // if 1 download solanum and the gif, if 2 download angel hair and gif
    // const materialUrl = materialName === "1" ? materialSolanum : materialAngelHair;
    let materialUrl, materialUrlName;

    if (await materialName === 1) {
      console.log("DownloadScreenCapButton: materialName", materialName);
       materialUrl = materialSolanum;
       materialUrlName = "Solanum.zip";
    } if (await materialName === 2) {
      console.log("DownloadScreenCapButton: materialName", materialName);
       materialUrl = materialAngelHair;
       materialUrlName = "AngelHair.zip";
    } 
    if (materialUrl && materialUrlName) {
      console.log("DownloadScreenCapButton: materialUrl", materialUrl);
      downloadFile(materialUrl, materialUrlName);
    }

    // const materialUrl = materialName === "1" ? materialSolanum : materialAngelHair;
    // const materialUrlName = materialName === "1" ? "Solanum.zip" : "AngelHair.zip";
    // console.log("DownloadScreenCapButton: materialUrl", materialUrl);
    // downloadFile(materialUrl, materialUrlName);

    // assets
    //  original image
    //  edited image
    //  highres transparency image
    //  rectangle geometry

    // collect parameters
    const PointJson = await sdApi.current.parameters.get({ name: "Points" }).data[0].value
    // const TForm1Json = await sdApi.current.parameters.get({ name: "TForm1" }).data[0].value
    const TForm1Json = await SDgetDataByName("TForm1", sdApi.current)
    const TForm2Json = await SDgetDataByName("TForm2", sdApi.current)
    const TweenNumber = await SDgetDataByName("TweenNumber", sdApi.current)
    // Height
    // Width
    // LinesPerFt
    // Rotation
    // material
    // image crop
    // this section should just return the paramDefs
    // at least descruturing the paramDefs

    const Height = await sdApi.current.parameters.get({ name: "Scope: Height" }).data[0].value
    const Width = await sdApi.current.parameters.get({ name: "Scope: Width" }).data[0].value
    const LinesPerFt = await sdApi.current.parameters.get({ name: "Lines: Per Ft" }).data[0].value
    const Rotation = await sdApi.current.parameters.get({ name: "Lines: Rotation" }).data[0].value
    const material = await sdApi.current.parameters.get({ name: "Material" }).data[0].value
    const imageCrop = await sdApi.current.parameters.get({ name: "Image: Crop/Stretch" }).data[0].value
    // return false if imageInvert is not found
    const tempimageInvert = await sdApi.current.parameters.get({ name: "Image Invert" }).data[0];
    // console.log("DownloadScreenCapButton: tempimageInvert", tempimageInvert);
    const imageInvert = typeof tempimageInvert  !== 'undefined' ? tempimageInvert.value : false;


    // these values are not always current for paramDefs. need to pull new global values
    // const Height = findParameterValue( "Scope: Height", paramDefs);
    // const Width = findParameterValue( "Scope: Width", paramDefs);
    // const LinesPerFt = findParameterValue( "Lines: Per Ft", paramDefs);
    // const Rotation = findParameterValue( "Lines: Rotation", paramDefs);
    // const material = findParameterValue("Material", paramDefs);
    // const imageCrop = findParameterValue("Image: Crop/Stretch", paramDefs);
    // // return false if imageInvert is not found
    // const imageInvert = findParameterValue("Image Invert", paramDefs) || false;
    // console.log("DownloadScreenCapButton: imageInvert", imageInvert);



    // console.log("DownloadScreenCapButton: returned", TForm1Json, PointJson);
    // const TForm2Json = await sdApi.current.parameters.get({ name: "TForm2" }).data[0].value DownloadContrastPNG
    await sdApi.current.parameters.updateAsync({ name: 'downloadNoMaterial', value: true}).then(
    await Promise.all([
      
      await sdApi.current.exports.requestAsync({ name: "DownloadContrastPNG" }).then((downloadResult) => {
        // download modified image

          // console.log("DownloadScreenCapButton: downloadResult", downloadResult.data.content[0].href);
          const dataImageEdit =  downloadResult.data.content[0].href; // Assuming data is not a Blob
          // console.log("DownloadScreenCapButton: _ImageLinesEdit", dataImageEdit);       
          setModifiedImageBlob(dataImageEdit);
          return dataImageEdit;
      }),
        //   fetchImageBinaryData(modifiedImageBlob).then((imageArrayBuffer ) => {
          
        //     // console.log("DownloadScreenCapButton: imageArrayBuffer", imageArrayBuffer);
        //     // Convert ArrayBuffer to Blob
        //     const imageBlob = new Blob([imageArrayBuffer], { type: "image/png" });
            
        //     downloadBlob(imageBlob, DesignID +"_ImageLinesEdit.png"); // Change the file extension as needed
        //     // console.log("DownloadScreenCapButton: ModifiedImageBlob", modifiedImageBlob);
        
     
        // }),

      
       sdApi.current.exports.requestAsync({ name: "DownloadPNG"}).then((downloadResult) => {
      // .then((response) => {  if (response['data']) setTimedOut(false);  }),

      // await sdApi.current.exports.requestAsync({ name: "DownloadPNG", parameters: { downloadNoMaterial: true } }).then((downloadResult) => {
        
      // if ( downloadResult.success) {
        // const imageBlob = downloadResult.data.content[0].blob;
        // need to convert to blob
        // and then modify the exif data
        // const dataImage =''

        console.log("DownloadScreenCapButton: downloadResult", downloadResult);
        const dataImage = downloadResult.data.content[0].href; // Assuming data is not a Blob
        // // console.log("DownloadScreenCapButton: sethighresImageBlob", dataImage);       
        sethighresImageBlob(dataImage);
        return dataImage;
      }),
      //   fetchImageBinaryData(highresImageBlob).then((imageArrayBuffer ) => {
        
      //     // console.log("DownloadScreenCapButton: imageArrayBuffer", imageArrayBuffer);
      //     // Convert ArrayBuffer to Blob
      //     const imageBlob = new Blob([imageArrayBuffer], { type: "image/png" });
          

      //     // // Read exif data
      //     // const exifObj = piexif.load(imageBlob);

      //     // // Write exif data
      //     // const newExifObj = {
      //     //   GPS: {
      //     //     GPSLatitude: 37.775,
      //     //     GPSLongitude: -122.418,
      //     //   },
      //     // };
      //     // const newExifBinary = piexif.dump(newExifObj);

      //     // // Edit exif data
      //     // const editedExifObj = piexif.insert(newExifBinary, exifObj);

      //     // Save exif data to a file
      //     // const fileBuffer = Buffer.from(editedExifObj, 'binary');
      //     // fs.writeFileSync('edited-image.jpg', fileBuffer);

      //     // Read the EXIF data from the downloaded image
      //     // const reader = new FileReader();
      //     // reader.onload = (event) => {
      //       // const modifiedImageBlob = modifyExifData(event.target.result);
      //       // const modifiedImageBlob = modifyExifData(imageArrayBuffer);
            
      //       downloadBlob(imageBlob, DesignID +"_ImageLines.png"); // Change the file extension as needed
      //     // };
      //     // reader.readAsArrayBuffer(imageBlob);
      // })
      await sdApi.current.exports.requestAsync({ name: "DownloadOriginalPNG" }).then((downloadResult) => {
        setBusyState(true)
        setProgress(0.7)
        // if ( downloadResult.success) {
          // const imageBlob = downloadResult.data.content[0].blob;
          // need to convert to blob
          // and then modify the exif data
          // console.log("DownloadScreenCapButton: downloadResult", downloadResult);
          const dataImageOriginal = downloadResult.data.content[0].href; // Assuming data is not a Blob
          // console.log("DownloadScreenCapButton: sethighresImageBlob", dataImageOriginal);       
          sethighresImageBlob(dataImageOriginal);
          return dataImageOriginal;
        }),


    ]).then(async ([modifiedImageBlobUrl, highresImageBlobUrl, originalImageBlobUrl]) => {

      // console.log("DownloadScreenCapButton: modifiedImageBlobUrl", modifiedImageBlobUrl);
      setBusyState(true)
      setProgress(0.9)
      // Fetch and process the binary data for modified image
      const  modifiedImageArrayBuffer = await fetchImageBinaryData(modifiedImageBlobUrl);
      const highresImageArrayBuffer = await fetchImageBinaryData(highresImageBlobUrl);
      const originalImageArrayBuffer = await fetchImageBinaryData(originalImageBlobUrl);

      // Fetch and process the binary data for highres image
      const modifiedImageBlob = new Blob([modifiedImageArrayBuffer], { type: "image/png" })
      // const uploadModified = await uploadBlobToStorage(modifiedImageBlob, DesignID +"_ImageLinesEdit.png");
      const uploadModified = await uploadBlobToStorage(modifiedImageBlob, "images/" + DesignID +"_ImageLinesEdit.png");

      const highresImageBlob = new Blob([highresImageArrayBuffer], { type: "image/png" });
      // const uploadHighRes = await uploadBlobToStorage(highresImageBlob, DesignID +"_ImageLines.png");
      const uploadHighRes = await uploadBlobToStorage(highresImageBlob, "images/" + DesignID +"_ImageLines.png");
      downloadBlob(highresImageBlob, DesignID +"_ImageLines.png");

      const originalImageBlob = new Blob([originalImageArrayBuffer], { type: "image/png" });
      const uploadOriginal = await uploadBlobToStorage(originalImageBlob, "images/" + DesignID +"_Original.png");
    
      // console.log("highresImageBlob", uploadModified);
      // console.log("modifiedImageBlob", uploadHighRes);
      // console.log("originalImageBlob", uploadOriginal);


        // 
        //create json object to write to firebase
        const dataSave = {
          "ProjectName": DesignID,
          "Points": PointJson,
          "TForm1": TForm1Json,
          "TForm2": TForm2Json,
          "Image": uploadOriginal,
          "ImageHighRes": uploadModified,
          "ImageEdited": uploadHighRes,
          "Rectangle": "imageBlob",
          "Height": Height,
          "Width": Width,
          "LinesPerFt": LinesPerFt,
          "Rotation": Rotation,
          "Material": material,
          "ImageCrop": imageCrop,
          "ImageInvert": imageInvert,
          "TweenNumber": TweenNumber,

          }

        console.log("DownloadScreenCapButton: dataSave", dataSave);

        setBusyState(false)
        setProgress(1)
        asyncLogParams("CaptureDownload", 1, dataSave);


    })
    )

    .then(
      await sdApi.current.parameters.updateAsync({ name: 'downloadNoMaterial', value: false})
    )
  // })

      // // Check if both blobs are ready before sending data to Firebase
      // if (modifiedBlobReady && highresBlobReady) {
      //   asyncLogParams("CaptureDownload", 1, dataSave);
      // } else {
      //   console.log("Blobs are not ready yet.");
      // }
  }

  const  onClick =  () => {
    console.log("DownloadScreenCapButton: onClick");

    // I don't like this user input method
    // setModal(true);
    // const userInput = prompt(`Name of project: `)
    downloadImage()
  };



  

  return (
    <div>
    <Button variant="contained" color="primary" startIcon={<CameraAltIcon />} onClick={onClick}> DOWNLOAD IMAGE </Button>
    {/* {modifiedImageBlob && (
        <a
          href={URL.createObjectURL(modifiedImageBlob)}
          download="modified_image.png"
        >
          Download Modified Image
        </a>
      )} */}
      {/* The popup will only be rendered when theshowModal state is true */}
      {/* {showModal && (
        <div className="popup">
          <Popup setUserInput={setUserInput} showModal={showModal} setModal={setModal} />
        </div>
      )} */}
    </div>
  )
}